import React, { useCallback, useEffect, useState } from 'react';
import { Button, Stack, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPartnersRequest, markPartnerCreated, markPartnerEdited } from '../../api/partners/partnerSlice';
import { DataGrid } from '@mui/x-data-grid';
import { debounce } from 'lodash';

const PartnerTable = () => {
  const dispatch = useDispatch();
  const { partners, totalCount } = useSelector((state) => state.partners);
  const [page] = useState(0);
  const [limit] = useState(10);
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    dispatch(markPartnerCreated(false));
    dispatch(markPartnerEdited(false));
    dispatch(fetchPartnersRequest({ page: page + 1, limit: limit }));
  }, [dispatch, page, limit]);

  const handleEditClick = (id) => {
    navigate(`/partners/edit/${id}`);
  };

  const handleSearchChange = useCallback(
    debounce((e) => {
      setSearchValue(e.target.value);
      dispatch(
        fetchPartnersRequest({
          page: 1,
          limit: 10,
          search_by: 'email',
          search_key: e.target.value,
        }),
      );
    }, 500), // Adjust debounce delay as needed (500ms)
    [dispatch],
  );

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1,
    },
    {
      field: 'documents_limit',
      headerName: 'Documents Limit',
      flex: 1,
      type: 'number',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'is_embedded',
      headerName: 'Partner Type',
      flex: 1,
      type: 'number',
      headerAlign: 'left',
      align: 'left',
      renderCell: (params) => (params.row.is_embedded ? 'Embedded' : 'Resale Partner'),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 0.5,
      sortable: false,
      renderCell: (params) => (
        <Button variant="outlined" color="primary" size="small" onClick={() => handleEditClick(params.row._id)}>
          Edit
        </Button>
      ),
    },
  ];

  return (
    <>
      <Stack
        sx={{
          justifyContent: 'flex-end',
          alignItems: 'end',
          mb: 1,
        }}
      >
        <TextField
          size={'small'}
          id={'search-eame'}
          label="Search by email"
          variant="outlined"
          onChange={handleSearchChange}
        />
      </Stack>
      <DataGrid
        rows={partners}
        columns={columns}
        getRowId={(row) => row._id}
        paginationMode="server"
        rowCount={totalCount}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: limit,
            },
          },
        }}
        pageSizeOptions={[10, 25]}
        disableRowSelectionOnClick
        onPaginationModelChange={(model) => {
          dispatch(
            fetchPartnersRequest({
              page: model.page + 1,
              limit: model.pageSize,
              search_by: 'email',
              search_key: searchValue,
            }),
          );
        }}
      />
    </>
  );
};

export default PartnerTable;
